import BaseLayout from '../components/base-layout';
import PageNotFound from './page-not-found';

export function PageNotFoundFactory() {
    return (
        <BaseLayout>
            <PageNotFound />
        </BaseLayout>
    );
}
